export enum CloverPointConnectionStatusType {
  UNSTABLE = "Unstable",
  CONNECTED = "Connected",
  DISCONNECTED = "Not connected",
  INACTIVE = "Inactive",
}